import {
    ApiClient,
    AuthApi,
    // AppApi
} from 'sandpiper_api';
import log from "@/utils/logger";
import router from "@/router";
// import jwt_decode from "jwt-decode";

export default {
    install: (app, options) =>
    {
        if (!options || !options.store)
        {
            throw new Error("Please initialise plugin with a Vuex store.");
        }

        const store = options.store;

        // Cookies need to be enabled so that the server can send the set cookie header for the refresh token
        ApiClient.instance.enableCookies = true;
        // Chrome doesn't like setting the user-agent header from javascript (even though it's allowed according to the spec)
        // and the openapi generator doesn't seem to have an obvious way to set that default user agent value to null.
        // Tried by adding different variations of `--http-user-agent` but it always complained about empty value.
        ApiClient.instance.defaultHeaders['User-Agent'] = null;

        if (process.env.VUE_APP_OPENAPI_URL_INDEX)
        {
            ApiClient.instance.basePath = ApiClient.instance.getBasePathFromSettings(process.env.VUE_APP_OPENAPI_URL_INDEX);
        }

        const doApiRequest = (request) =>
        {
            // NOTE: this setup doesn't work for requests that don't require authentication. We could fix this by overriding
            // the ApiClient and putting the token refresh logic in there (since we know from the openapi schema if an
            // authentication is required when it is passed to the ApiClient). For now, just use the old setup that
            // immediately calls the initial request and tries to refresh tokens if that fails.

            // if (getCurrentJwtInfo().isValid)
            // {
            //   return request()
            //     .then(apiSuccessHandler)
            //     .catch(e => apiAccessDeniedHandler(e, request))
            //     .catch(apiErrorHandler);
            // }
            // else
            // {
            //   return tryRefreshAccessToken()
            //     .then(request)
            //     .then(apiSuccessHandler)
            //     .catch(apiErrorHandler);
            // }

            return request()
                .then(apiSuccessHandler)
                .catch(e => apiAccessDeniedHandler(e, request))
                .catch(apiErrorHandler);

            function apiSuccessHandler(response)
            {
                log.info("Request response: %o", response);
                return response;
            }

            function apiAccessDeniedHandler(e, initialRequest)
            {
                if (e.body && (e.body.error === "ACCESS_TOKEN_EXPIRED" || e.body.error === "ACCESS_DENIED"))
                {
                    log.error("Access denied - will try to request new access token and re-execute initial request - %o", e);

                    return tryRefreshAccessToken()
                        .then(initialRequest)
                        .then(apiSuccessHandler)
                }
                else
                {
                    throw e;
                }
            }

            /**
             * Handler that will try to request a new access token for the first authentication failure. If we are unable
             * to request a new token then the user will be redirected to the login page
             */
            function tryRefreshAccessToken()
            {
                log.info("Trying to refresh access token");

                return new AuthApi().refreshTokens({ invalidateToken: false })
                    .then(response =>
                    {
                        log.info("Successfully requested new access token"); // Don't log access token!

                        // let auth = ApiClient.instance.authentications["oAuth2Password"];
                        // auth.accessToken = response.access_token;

                        store.commit("security/setJwtToken", response.access_token);

                        return response;
                    })
                    .catch(e =>
                    {
                        // If any error occurred while trying to refresh the access token, redirect to the login page
                        log.info("Auth error, unable to refresh access token. Redirecting to login page. - %o", e);
                        router.push({ name: 'login' });
                        throw e;
                    });
            }

            /**
             * Handler for all API exception EXCEPT FOR ACCESS_TOKEN_EXPIRED
             * @param e Error object
             */
            function apiErrorHandler(e)
            {
                if(!e.body && !e.error.status)
                {
                    log.warn("Unable to reach server. Server offline?");
                }

                log.error("API exception - %o", e);
                throw e;
            }
        };

        app.config.globalProperties.$doApiRequest = doApiRequest;
        app.provide("doApiRequest", doApiRequest);

        // const getCurrentJwtInfo = () =>
        // {
        //     let accessToken = ApiClient.instance.authentications['oAuth2Password'].accessToken;
        //     let jwtPayload = null;
        //     if (accessToken)
        //     {
        //         jwtPayload = jwt_decode(accessToken);
        //     }
        //
        //     log.info("JWT payload: %o", jwtPayload);
        //
        //     return {
        //         payload: jwtPayload,
        //         isValid: jwtPayload !== null && new Date() < new Date(jwtPayload.exp * 1000),
        //
        //         hasRole: (role) =>
        //         {
        //             if (jwtPayload === null) return false;
        //             let userRoles = jwtPayload?.secRoles.split(",") || [];
        //             return userRoles.includes(role);
        //         }
        //     }
        // };
        //
        // app.config.globalProperties.$getCurrentJwtInfo = getCurrentJwtInfo;
        // app.provide("getCurrentJwtInfo", getCurrentJwtInfo);
    }
}